<template>
  <div id="app">
    <TermsModal></TermsModal>
    <component :is="layout">
    </component>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import TermsModal from '@/pages/supplier/terms/TermsModal';

export default {
  components: { TermsModal },
  name: 'App',
  computed: {
    ...mapGetters('auth', [
      'isAuthenticated',
      'currentUser',
    ]),
    ...mapState('termsAndConditions', ['areTermsAndConditionsRequired']),
    layout() {
      return `${(this.$route.meta.layout || 'default')}-layout`;
    },
  },
  beforeCreate() {
    this.$store.dispatch('auth/assignRoutes');
  },
  created() {
    this.isAuthenticated.then(async (userInfo) => {
      if (userInfo && !this.currentUser) {
        if (window.appInsights) {
          window.appInsights.setAuthenticatedUserContext(userInfo.profile.preferred_username.replace(/[,;=| ]+/g, '_'));
        }
        const isMroMdmUser = Array.isArray(userInfo.profile.role) ? userInfo.profile.role.find(role => role.toUpperCase().includes("MRO_MDM_USER")) : userInfo.profile.role.toUpperCase().includes('MRO_MDM_USER');
        if (isMroMdmUser) {
          window.localStorage.setItem('role', "mro_mdm_user");
          await this.$store.dispatch('materials/GET_WORKFLOW_ID', { tax_id: userInfo.profile['x-hasura-organization-id'] });
          await this.$store.dispatch('materials/getWorkflowUser', { userUUID: userInfo.profile['x-hasura-user-id'] });
          this.$store.dispatch('materials/GET_WORKFLOW_ACTIONS');
        }
        await this.$store.dispatch('auth/setCurrentUser', userInfo);
        if (userInfo.profile) {
          const isSupplier = Array.isArray(userInfo.profile.role) ? userInfo.profile.role.find(role => role.toLowerCase().includes('supplier')) : userInfo.profile.role.toLowerCase().includes('supplier');
          if (isSupplier) {
            this.$store.dispatch('termsAndConditions/areTermsAndConditionsRequired', { tax_id: userInfo.profile['x-hasura-organization-id'], userID: userInfo.profile['x-hasura-user-id'] });
            const now = new Date();
            const backdate = new Date(now.setDate(now.getDate() - 15)); // Son 15 días luego de haberse aceptado
            this.$store.dispatch('termsAndConditions/showRedGlobeNotification', { tax_id: userInfo.profile['x-hasura-organization-id'], date: backdate.toISOString() });
            this.$store.dispatch('dashboard/fetchUserPortals');
          } else this.$store.dispatch('auth/setLoadingDefaultPageToFalse');
        }
        await this.$store.dispatch('auth/getUserProfile');
        const defaultRole = window.localStorage.getItem('role');
        if (!defaultRole) {
          this.$router.push({ path: '401' }).catch(window.console.error);
        }
        const redirectPath = window.localStorage.getItem('auth:redirect');
        if (redirectPath) {
          window.localStorage.removeItem('auth:redirect');
          this.$router.push({
            path: redirectPath,
          }).catch(() => {});
        }
      }
    });
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/App.vue